import React, { useState } from 'react'
import PropTypes from 'prop-types'
import Snackbar from '@mui/material/Snackbar'
import SnackbarContent from '@mui/material/SnackbarContent'
import Button from '@mui/material/Button'
import NotificationCenterContext from './NotificationCenterContext'
import styled from 'styled-components';
import theme from 'config/theme';

const StyledSnackbarContent = styled(({ type, ...rest }) => (
  <SnackbarContent
    {...rest}
  />))`
  &&{
     background: ${props => {
       if (props.type === 'error') return theme.palette.error.main;
       if (props.type === 'success') return '#4caf50';
       return '#323232';
     }};
     color: #fff;
     font-size: 12px;
     font-weight: 500;
     font-family: 'Roboto';
     border-radius: 4px;
     box-shadow: 0 3px 5px -1px rgba(0,0,0,0.2), 0 6px 10px 0 rgba(0,0,0,0.14), 0 1px 18px 0 rgba(0,0,0,0.12);
     & .MuiSnackbarContent-message {
       padding: 6px 16px;
     }
  }
`;

// Action button style override for download link color
const ActionButton = styled(Button)`
  && {
    color: #53C4CC;
  }
`;

const NotificationCenterProvider = (props) => {
  const { children } = props;

  const [message, setMessage] = useState(null);
  const [open, setOpen] = useState(false);
  const [type, setType] = useState('info');
  const [action, setAction] = useState(null);
  const [handleAction, setHandleAction] = useState(null);
  const [actionDownloadLink, setActionDownloadLink] = useState(null);

  const show = (message,
                type = 'info',
                action,
                handleAction,
                actionDownloadLink,
                ) => {
    let renderMessage = 'Unknown error';
    
    if (typeof message === 'string') {
      renderMessage = message;
    } else if (message && typeof message === 'object') {
      // Handle error objects
      renderMessage = message.message || message.error || message.toString();
    }

    setOpen(true);
    setType(type || 'info');
    setMessage(renderMessage);
    setAction(action);
    setHandleAction(() => () => {
      handleAction()
    });
    setActionDownloadLink(actionDownloadLink);
  }

  const showDownloadNotification = (downloadLink) => {
    setOpen(true);
    setType('info');
    setAction('Download');
    setMessage('If download failed, please click here');
    setActionDownloadLink(downloadLink);
  }

  const handleActionClick = () => {
    handleAction();
    handleClose();
  }

  const handleClose = () => {
    setOpen(false);
    setHandleAction(null);
  }
  return (
    <React.Fragment>
      <NotificationCenterContext.Provider
        value={{
          show: show,
          showDownloadNotification: showDownloadNotification,
        }}
      >
        {children}
      </NotificationCenterContext.Provider>
      <Snackbar
        open={open}
        autoHideDuration={actionDownloadLink ? 10000 : 5000}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <StyledSnackbarContent
          type={type}
          message={message || ''}
          action={action != null && (
            <ActionButton
              color="secondary"
              size="small"
              download
              href={actionDownloadLink && actionDownloadLink}
              target={actionDownloadLink && '_blank'}
              onClick={handleAction && handleActionClick}
            >
              {action}
            </ActionButton>
          )}
        />
      </Snackbar>
    </React.Fragment>
  )

}

export default NotificationCenterProvider;

NotificationCenterProvider.propTypes = {
  children: PropTypes.node,
}